import { useGlobalStore } from '@shared/store';

// 初始化页面来源：工作台 or 推送消息
export const initSourceType = async () => {
  useGlobalStore().setSourceType();
};
